<template>
  <div class="checkbox-group">
    <p class="subtitle-2 grey--text text--darken-1 mb-0 mt-3" v-text="data.text"></p>
    <p class="text-caption mb-0 grey--text text--darken-1" v-text="data.placeholder"></p>
    <span v-for="(opt, key) in data.options" :key="key" class="d-inline-block pr-5 pb-5">
      <v-checkbox v-model="data.value" :label="opt.text" :value="opt.value" hide-details class="mt-2"></v-checkbox>
    </span>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  created() {
    if (this.data.value.constructor !== Array) {
      this.data.value = [];
    }
  }
};
</script>

<style>
</style>